import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Avatar, Spin } from 'antd';
import Flex from 'cl-library/dist/components/shared-components/Flex'
import utils from '../utils/index';
const CardData = ({ data }) => {
    const avatarSize = 50;
    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState(data);
    useEffect(() => {
        async function fetchData() {
            data.map((obj) => {
                if (!obj.Student_Name) {
                    obj.Student_Name = "No Name"
                }
            })
            setTableData(data);
            setLoading(false);
        }
        fetchData();
    }, [data]);


    return (
        loading ? (<Spin tip='loading'></Spin>) :
            <>
                {tableData.map((stu, index) => (
                    <Card key="">
                        <Row justify="center">
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                <div className="d-flex">
                                    <div className="rounded p-2 bg-white shadow-sm mx-auto" style={{ 'marginTop': '-2.0rem', 'maxWidth': `${avatarSize + 16}px`, 'maxHeight': '70px' }}>
                                        <Avatar className="font-size-sm" style={{ backgroundColor: '#04d182' }} size={avatarSize}>
                                            {utils.getNameInitial(stu.RM_Name)}
                                        </Avatar>
                                    </div>
                                    <div className="ml-md-4 w-100">
                                        <Flex alignItems="center" mobileFlex={false} className="mb-3 text-md-left text-center">
                                            <h2 className="mb-0">{stu.RM_Name}</h2>
                                        </Flex>
                                    </div>
                                </div>
                                <Row gutter={[8, 8]}>
                                    <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                        <Row>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                <span className="text-muted ml-1">RMcode</span>
                                            </Col>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                <span className="font-weight-semibold">{stu.RMcode}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row gutter={[8, 8]}>
                                    <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                        <Row>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                <span className="text-muted ml-1">Reason</span>
                                            </Col>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                <span className="font-weight-semibold">{stu.Reason ? stu.Reason : "No Data"}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row gutter={[8, 8]}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                        <Row>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} >
                                                <span className="text-muted ml-1">Status</span>
                                            </Col>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                <span className="font-weight-semibold">{stu.Status ? stu.Status : "No Data"}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card>
                )
                )
                }
            </>
    )
}

export default CardData;